import * as Yup from "yup";

export const timelogBulkValidationSchema = Yup.object().shape({
  companyCode: Yup.number().required("Company code is required"),
  fromDate: Yup.string().required("From date is required"),
  toDate: Yup.string().required("To date is required"),
  locationCode: Yup.string().required("Location code is required"),
  employeeCode: Yup.number().required("Select Employee"),

  selectedEmployees: Yup.array().when("employeeCode", {
    is: 0,
    then: Yup.array()
      .of(Yup.string().required("Employee code is required"))
      .min(1, "At least one employee code is required"),
    otherwise: Yup.array().notRequired(),
  }),

  inTime: Yup.string().required("In time is required"),
  outTime: Yup.string().required("Out time is required"),
  projectCode: Yup.string().nullable(),
  shiftId: Yup.string().nullable(),
});


// export const timelogBulkValidationSchema = Yup.object().shape({
//   // companyCode: Yup.number().required("Company code is required"),
//   fromDate: Yup.string().required("From date is required"),
//   toDate: Yup.string().required("To date is required"),
//   // locationCode: Yup.string().required("Location code is required"),
//   bulkAttendance: Yup.array()
//     .of(
//       Yup.object().shape({
//         employeeCodes: Yup.array()
//           .of(Yup.number().required("Employee code is required"))
//           .min(1, "At least one employee code is required"),
//         attendanceValue: Yup.number().required("Attendance value is required"),
//         inTime: Yup.string().required("In time is required"),
//         outTime: Yup.string().required("Out time is required"),
//         createUser: Yup.string().required("Create user is required"),
//         createDate: Yup.string().required("Create date is required"),
//         modifyUser: Yup.string().required("Modify user is required"),
//         modifyDate: Yup.string().required("Modify date is required"),
//         scheduleId: Yup.number().required("Schedule ID is required"),
//         projectCode: Yup.string().nullable(),
//         shiftId: Yup.string().nullable(),
//         remarks: Yup.string(),
//         mode: Yup.string(),
//         waitingTime: Yup.string(),
//         isApproved: Yup.boolean(),
//         oT1: Yup.number(),
//         oT2: Yup.number(),
//         extraCharge: Yup.number(),
//         wtrot: Yup.string(),
//         wtnhEdit: Yup.boolean(),
//         supplierCompany: Yup.string(),
//         service: Yup.string(),
//         isReviewed: Yup.boolean(),
//         reviewDate: Yup.string(),
//         reviewBy: Yup.string(),
//         approvedDate: Yup.string(),
//         approvedBy: Yup.string(),
//         haveSplit: Yup.boolean(),
//         haveShift: Yup.boolean(),
//       })
//     )
//     .min(1, "At least one attendance record is required")
//     .required("Bulk attendance is required"),
// });